<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.become-member-form {
    .v-select {
        box-shadow: none;
    }

    .vs__dropdown-toggle {
        padding: 0 0 16px 16px;
    }

    .vs__search,
    .vs__search:focus {
        margin: 16px 0 0 0;
    }

    .vs__dropdown-option {
        padding: 8px 16px;
    }

    .vs__selected {
        margin: 16px 0 0 0;
    }

    .vs__actions {
        padding: 16px 16px 0 16px;
    }
}
</style>

<template>
    <div class="become-member-form" :class="{'processing': processing}">
        <div class="container">
            <div class="form-wrapper">
                <div class="form" id="become-member-form" ref="form" :class="{'processing': processing}">
                    <div class="text-center" v-if="title || description">
                        <h2 class="mb-24">{{ title }}</h2>
                        <p class="mb-40" v-if="description">{{ description }}</p>
                    </div>

                    <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent>
                        <div ref="page1" :class="page === 0 ? 'd-block' : 'd-none'">
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="first_name" vid="first_name" rules="required|min:2" v-slot="props" :name="translations.first_name" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="first_name">{{ translations.first_name }}</label>
                                            <input type="text" id="first_name" class="form-control" :placeholder="translations.first_name" @blur="validatePage1" @input="validatePage1" v-model="formData.first_name" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props" :name="translations.name" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="name">{{ translations.name }}</label>
                                            <input type="text" id="name" class="form-control" :placeholder="translations.name" @blur="validatePage1" @input="validatePage1" v-model="formData.name" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="email">{{ translations.email }}</label>
                                            <input type="email" id="email" class="form-control" :placeholder="translations.email" @blur="validatePage1" @input="validatePage1" v-model="formData.email" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="phone" vid="phone" :rules="{ required: true, regex:/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/}" v-slot="props" :name="translations.phone" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="phone">{{ translations.phone }}</label>
                                            <input type="text" id="phone" class="form-control" :placeholder="translations.phone" @blur="validatePage1" @input="validatePage1" v-model="formData.phone" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row mb-40">
                                <div class="col-12">
                                    <ValidationProvider ref="riziv" vid="riziv" :rules="{ required: true, regex:/(\d-\d{5}-\d{2}-\d{3})/}" v-slot="props" :name="translations.riziv" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="riziv">{{ translations.riziv }}</label>
                                            <the-mask :mask="'#-#####-##-###'" :masked="true" @change.native="onMaskChange" id="riziv" class="form-control" :placeholder="translations.riziv" v-model="formData.riziv" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="street" vid="street" rules="required" v-slot="props" :name="translations.street" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="street">{{ translations.street }}</label>
                                            <input type="text" id="street" class="form-control" :placeholder="translations.street" @blur="validatePage1" @input="validatePage1" v-model="formData.street" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="number" vid="number" rules="required" v-slot="props" :name="translations.number" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="number">{{ translations.number }}</label>
                                            <input type="text" id="number" class="form-control" :placeholder="translations.number" @blur="validatePage1" @input="validatePage1" v-model="formData.number" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="postal_code" vid="postal_code" rules="required|min:4|max:4|numeric|min_value:1000" v-slot="props" :name="translations.postal_code" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="postal_code">{{ translations.postal_code }}</label>
                                            <input type="text" id="postal_code" class="form-control" :placeholder="translations.postal_code" @blur="validatePage1" @input="validatePage1" v-model="formData.postal_code" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="place" vid="place" rules="required|min:2" v-slot="props" :name="translations.place" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="place">{{ translations.place }}</label>
                                            <input type="text" id="number" class="form-control" :placeholder="translations.place" @blur="validatePage1" @input="validatePage1" v-model="formData.place" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 text-right">
                                    <button @click.stop="nextPage" class="btn btn-lg mt-32 btn-secondary btn-special mb-56 mb-md-0"><span>{{ translations.next }}</span></button>
                                </div>
                            </div>
                        </div>
                        <div v-if="page === 1">
                            <div class="form-row">
                                <div class="col-12">
                                    <label>{{ translations.payment_type }}</label>
                                    <div class="form-group position-relative">
                                        <v-select v-model="formData.payment_type" :options="payment_types" :clearable="false" :searchable="false"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12">
                                    <ValidationProvider ref="registration_number" vid="registration_number" :rules="{ required: false, regex:/([01]\d{3}\.\d{3}\.\d{3})/}" v-slot="props" :name="translations.registration_number" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="registration_number">{{ translations.registration_number }}</label>
                                            <the-mask :mask="'####.###.###'" :masked="true" @change.native="onRegistrationNumberChange" id="registration_number" class="form-control" :placeholder="translations.registration_number" v-model="formData.registration_number" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="has_partnership" vid="has_partnership" v-slot="props" :name="translations.has_partnership" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <input type="checkbox" id="has_partnership" v-model="formData.has_partnership" />
                                            <label class="checkbox" :class="{'checked': formData.has_partnership}" for="has_partnership" v-html="translations.has_partnership"></label>
                                            <span class="error error-top">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ValidationProvider ref="vat_liable" vid="vat_liable" v-slot="props" :name="translations.vat_liable" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <input type="checkbox" id="vat_liable" v-model="formData.vat_liable" />
                                            <label class="checkbox" :class="{'checked': formData.vat_liable}" for="vat_liable" v-html="translations.vat_liable"></label>
                                            <span class="error error-top">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row" v-if="formData.has_partnership || formData.vat_liable">
                                <div class="col-12" v-if="formData.has_partnership" :class="{ 'col-md-6': formData.has_partnership && formData.vat_liable }">
                                    <ValidationProvider ref="partnership_name" vid="partnership_name" rules="min:2|required_if:has_partnership,true" v-slot="props" :name="translations.partnership_name" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="partnership_name">{{ translations.partnership_name }}</label>
                                            <input type="partnership_name" id="partnership_name" class="form-control" :placeholder="translations.partnership_name" v-model="formData.partnership_name" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12" v-if="formData.vat_liable" :class="{ 'col-md-6': formData.has_partnership && formData.vat_liable }">
                                    <ValidationProvider ref="vat_number" vid="vat_number" :rules="{ required: formData.vat_liable === true, regex:/^(BE)?0[0-9]{9}$/}" v-slot="props" :name="translations.vat_number" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <label for="vat_number">{{ translations.vat_number }}</label>
                                            <input type="text" id="vat_number" class="form-control" :placeholder="translations.vat_number" v-model="formData.vat_number" />
                                            <span class="error">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <!--
                            <div class="form-row">
                                <div class="col-12">
                                    <ValidationProvider ref="conditions_accepted" vid="conditions_accepted" :rules="{required: { allowFalse: false }}" v-slot="props" :name="'Je gaat akkoord'" :slim="true">
                                        <div class="form-group position-relative" :class="props.classes">
                                            <input type="checkbox" id="conditions_accepted" v-model="formData.conditions_accepted" />
                                            <label class="checkbox" :class="{'checked': formData.conditions_accepted}" for="conditions_accepted">
                                                Je kiest voor 1 maand gratis lidmaatschap van de CTP Community. Indien je het lidmaatschap opzegt binnen de maand, stopt je lidmaatschap na 1 maand en ontvang je van CtpConnect geen factuur.
                                                Indien je niet binnen de maand opzegt, wordt je abonnement hierna verlengd voor 12 maanden en ontvang je na de 1e maand een factuur van €275 voor lidmaatschap voor 1 jaar.
                                                Na verzending van dit formulier, ontvang je mails met onder meer informatie over het klantenportaal en de voordelen van CTP Community.
                                            </label>
                                            <span class="error error-top">{{ props.errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            -->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between">
                                        <button @click.stop="previousPage" class="btn btn-lg mt-32 btn-lightgray mb-56 mb-md-0">{{ translations.previous }}</button>
                                        <button @click.stop="submit('/signup')" class="btn btn-lg mt-32 btn-secondary btn-special mb-56 mb-md-0"><span>{{ translations.submit }}</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ValidationObserver>

                    <div class="spinner-background">
                        <div class="spinner">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formBaseRecaptcha from '@mixins/formBaseRecaptcha'
import vSelect from 'vue-select'
import { TheMask } from "vue-the-mask";

export default {
    name: 'become_member_form',

    components: {
        vSelect,
        TheMask,
    },

    mixins: [formBaseRecaptcha],

    props: {
        title: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        subtitle: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            page: 0,
            page1valid: false,
            payment_types: [/*{ label: '€25/maand', value: 'monthly' }, */{ label: '€275/jaar', value: 'yearly' }],
            // payment_types: [{ label: '1 maand gratis lidmaatschap', value: 'free_month' }],
            formData: {
                first_name: "",
                name: "",
                email: "",
                phone: "",
                street: "",
                number: "",
                postal_code: "",
                place: "",
                has_partnership: false,
                partnership_name: "",
                vat_number: "",
                vat_liable: false,
                payment_type: { label: '€275/jaar', value: 'yearly' },
                riziv: null,
                //conditions_accepted: false,
                registration_number: null,
            }
        }
    },

    methods: {
        async nextPage() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.page = 1;
            }
        },
        previousPage() {
            this.page = 0;
        },
        validatePage1() {
            this.page1valid = this.$refs.page1.querySelectorAll(".form-group").length == this.$refs.page1.querySelectorAll(".form-group.passed").length;
        },
        onMaskChange(event) {
            this.$refs.riziv.validate(event.target.value);
        },
        onRegistrationNumberChange(event) {
            this.$refs.registration_number.validate(event.target.value);
        },
    },

    computed: {
        pageOneIsInvalid() {
            return !this.page1valid;
        }
    }
}
</script>
